import {
  REFERRAL_CHECKOUT_VALIDATION_TIMEOUT_MS,
  REFERRAL_LINK_INFO_GLOBAL
} from '../referral-bar/constants';

export const getReferralCheckoutCartAttributes = async () => {
  const linkInfo = window[REFERRAL_LINK_INFO_GLOBAL];

  if (!linkInfo) {
    return {};
  }

  const timeout = new Promise((resolve) => {
    setTimeout(resolve, REFERRAL_CHECKOUT_VALIDATION_TIMEOUT_MS);
  });
  const data = await Promise.race([linkInfo.validation.catch(() => {}), timeout]);

  return data?.valid ? { [linkInfo.tokenKey]: linkInfo.token } : {};
};
